import React from "react";

const GlobalLoader = () => {
    return (
        <div className="fixed inset-0 flex items-center justify-center bg-white bgSurfaceDark z-[9999]">
            <div className="flex flex-col items-center space-y-3">
                {/* Spinner */}
                <div className="w-10 h-10 border-4 border-teal-500 dark:border-white border-t-transparent rounded-full animate-spin"></div>

                {/* Optional Text */}
                <p className="text-gray-700 dark:text-white text-sm font-medium tracking-wide">
                    Workfreeli Loading...
                </p>
            </div>
        </div>
    );
};

export default GlobalLoader;
